export default "__VITE_ASSET__35967e22__"